import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentUser: null,
  isAdmin: false,
  previousAdminId: null,
  dashboardNumberTimeInterval: {
    name: "1 Month",
    code: "month", // Default time interval for dashboard numbers
  },
  dashboardGraphTimeInterval: {
    name: "1 Month",
    code: "month", // Default time interval for dashboard numbers
  },
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.currentUser = action.payload;
      state.isAdmin = action.payload.role === "admin";
      state.previousAdminId =
        action.payload.role === "admin" ? action.payload?._id : null;
    },
    changeUserSuccess: (state, action) => {
      state.currentUser = action.payload;
    },
    changePreviousAdminId: (state, action) => {
      state.previousAdminId = action.payload?.previousAdminId
        ? action.payload?.previousAdminId
        : state.previousAdminId;
    },
    logout: (state) => {
      state.currentUser = null;
      state.isAdmin = false;
      state.previousAdminId = null;
    },
    isAdminSuccess: (state, action) => {
      state.isAdmin = action.payload;
    },
    changeDashboardNumberTimeInterval: (state, action) => {
      state.dashboardNumberTimeInterval = action.payload;
    },
    changeDashboardgraphTimeInterval: (state, action) => {
      state.dashboardGraphTimeInterval = action.payload;
    },
  },
});

export const {
  loginSuccess,
  logout,
  isAdmin,
  changeUserSuccess,
  isAdminSuccess,
  changeDashboardNumberTimeInterval,
  changeDashboardgraphTimeInterval,
  changePreviousAdminId,
} = userSlice.actions;

export default userSlice.reducer;
